import {
  Box,
  Button,
  Card,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Fade,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  Stack,
  TextField,
  Typography
} from '@mui/material';
import dayjs from "dayjs";
import { Close } from 'mdi-material-ui';
import { forwardRef, useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import DatesPicker from 'src/components/mui/datespicker';
import { apiService } from '../../api/axiosClient';
import Editor from '../../components/editor';


const Transition = forwardRef((props, ref) => <Fade ref={ref} {...props} />)

const DialogPopup = (props) => {
  const { show, setShow, reload, setReload } = props
  const [loading, setLoading] = useState(false)
  const [content, setContent] = useState('');
  const [daterange, setDateRange] = useState({
    startname: '시작일시',
    startdate: new Date(),
    endname: '종료일시',
    enddate: new Date()
  });
  const defaultValues = {
    title: '',
    resume: '7'
  }
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({ defaultValues });

  useEffect(() => {
    if(!show) {
      reset(defaultValues);
      setContent('');
    }
  },[show])

  const onSubmit = async (data, e) => {
    setLoading(true)

    const params = {
      "title": data.title,
      "descript": content,
      "resume": data.resume,
      "fromdate": dayjs(daterange.startdate).format("YYYY-MM-DD"),
      "todate": dayjs(daterange.enddate).format("YYYY-MM-DD")
    };

    try {
      await apiService.post('/popups', params);
      toast.success('업데이트 되었습니다.');
      setReload(reload+1);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setShow(false);
    }
  }

  return (
    <Card>
      <Dialog
        fullWidth
        open={show}
        maxWidth='md'
        scroll='body'
        onClose={() => setShow(false)}
        TransitionComponent={Transition}
        onBackdropClick={() => setShow(false)}
      >
        <form onSubmit={handleSubmit(onSubmit)} id="popupform">
          <DialogContent sx={{ pb: 3, px: { xs: 8, sm: 15 }, pt: { xs: 4, sm: 8 }, position: 'relative' }}>
            <IconButton
              size='small'
              onClick={() => setShow(false)}
              sx={{ position: 'absolute', right: '1rem', top: '1rem' }}
            >
              <Close />
            </IconButton>
            <Box sx={{ mb: 4, textAlign: 'center' }}>
              <Typography variant='h5' sx={{ mb: 3, lineHeight: '2rem' }}>
                팝업 추가
              </Typography>
            </Box>

            <Grid container spacing={6}>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <Controller
                    name='title'
                    control={control}
                    rules={{ required: true }}
                    render={({ field: { value, onChange } }) => (
                      <TextField
                        value={value}
                        label='제목'
                        id='title'
                        onChange={onChange}
                        placeholder='제목을 입력해주세요'
                        error={Boolean(errors.title)}
                        aria-describedby='validation-async-title'
                      />
                    )}
                  />
                  {errors.title && (
                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-title'>
                      필수
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>

              <Grid item xs={12}>                
                <Stack direction="row" spacing={3} >
                  <FormControl>
                    <Controller
                      name='resume'
                      control={control}
                      rules={{ required: true }}
                      defaultValue="7"
                      render={({ field: { value, onChange } }) => (
                        <TextField
                          value={value}
                          label='재개날짜'
                          id='resume'
                          onChange={onChange}
                          placeholder='고객이 다시 보지 않음을 선택할 시 몇 일후 팝업레이어를 보여주는 것을 설정합니다.'
                          error={Boolean(errors.resume)}
                          aria-describedby='validation-async-resume'
                        />
                      )}
                    />
                    {errors.resume && (
                      <FormHelperText sx={{ color: 'error.main' }} id='validation-async-resume'>
                        필수
                      </FormHelperText>
                    )}
                  </FormControl>
                  <DatesPicker daterange={daterange} setDateRange={setDateRange} />
                </Stack>
              </Grid>

              <Grid item xs={12}>
                <Controller
                  name='content'
                  control={control}
                  render={({ field: { value } }) => (
                  <Editor 
                    content={value}
                    setContent={setContent} />
                  )}
                />
              </Grid>

            </Grid>
          </DialogContent>
        </form>

        <DialogActions sx={{ pb: { xs: 4, sm: 8 }, justifyContent: 'center' }}>
          <Button type="submit" form="popupform" variant='contained'>
            {loading ? (
              <CircularProgress
                sx={{
                  color: 'common.white',
                  width: '20px !important',
                  height: '20px !important',
                  mr: theme => theme.spacing(2)
                }}
              />
            ) : null}
            등록
          </Button>
          <Button variant='outlined' color='secondary' onClick={() => setShow(false)}>
            취소
          </Button>
        </DialogActions>

      </Dialog>
    </Card>
  )
}

export default DialogPopup
